import React from 'react';
import { IMainContentProps, IMainProps } from 'telia-front-react';
import config from '../Config';

interface WrapWithComponentInFullPageProps {
  Component: React.ComponentType<IMainProps> | React.ComponentType<IMainContentProps>;
  children: React.JSX.Element;
}

const WrapWithComponentInFullPage = (props: WrapWithComponentInFullPageProps): React.JSX.Element => {
  const { Component, children } = props;
  const isModule = config.isModule;

  if (isModule) {
    return children;
  }
  return <Component>{children}</Component>;
};

export default WrapWithComponentInFullPage;
